<template>
  <div class="news-list">
    <el-table
    :data="newsList"
    stripe
    class="news-table"
    >
      <el-table-column
        prop="title"
        label="文章标题"
        >
      </el-table-column>
      <el-table-column
        prop="issueTime"
        label="发布日期"
        width="150"
        >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建日期"
        width="150"
        >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改日期"
        width="150"
        >
      </el-table-column>
      <el-table-column
        label="操作"
        width="300"
        align="center"
        >
        <template slot-scope="{ row }">
          <el-button @click="editHandle(row)" size="mini">修改文章</el-button>
          <el-button @click="delHandle(row)" size="mini" type="danger" plain>删除文章</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="news-pag"
      background
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="currentPage"
      @current-change="getNewsList"
      >
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      newsList: [],
      total: 0,
      currentPage: 1,
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      let paramObj = {
        page: this.currentPage,
        pageSize: 10,
        issueTime: '1'
      }
      axios({
        url: `${this.$store.state.apiUrlZero}/TuZero/selectNews`,
        method: 'post',
        data: paramObj
      }).then(res => {
        // console.log(res)
        this.newsList = [...res.data.data.list]
        this.total = res.data.data.total
      })
    },
    delHandle(data) {
      this.$confirm('确认删除这篇文章吗','提示',{type:'warning'})
      .then(()=> {
        axios({
          url: `${this.$store.state.apiUrlZero}/TuZero/deleteNews`,
          method: 'delete',
          data: {
            id: data.id,
            newsArticleId: data.newsArticleId
          }
        })
        .then(res => {
          this.$message.success('已删除')
          this.getNewsList()
        })
        .catch(error => {
          this.$message.error('删除失败')
          console.log(error)
        })
      })
    },  
    editHandle(data) {
      this.$router.push({
        path: '/zero/subNews',
        query: {
          ...data,
          sign: 'edit'
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  padding: 20px;
  background-color: #fff;

  .news-table {

  }
  .news-pag {
    margin-top: 10px;
  }
}
</style>